import React, { ChangeEventHandler, ComponentProps } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import BaseInput from '@/components/form/base/BaseInput.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';

type TextInputProps = {
  label?: string;
  register: UseFormRegisterReturn;
  required?: boolean;
  error?: string;
  hint?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
} & Omit<ComponentProps<'input'>, 'onChange' | 'required'>;

export const TextInput = ({
  label,
  register,
  required = false,
  disabled = false,
  error,
  hint,
  onChange,
  type = 'text',
  ...props
}: TextInputProps) => {
  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      {label && (
        <InputLabel label={label} required={required} disabled={disabled} />
      )}
      <BaseInput
        {...props}
        type={type}
        register={register}
        disabled={disabled}
        error={error}
        onChange={onChange}
      />
      <InputError error={error} />
      <InputHint hint={hint} />
    </div>
  );
};
